export default __webpack_public_path__ + "static/media/laptop.839c670d.svg";